export default __webpack_public_path__ + "static/globalconnect-b3ff12cee2f45dc93eba872324351644.png";